import React from "react";
import "../../components/popup/ForcedPopup.css";

const FirstMessage = () => {
  return (
    <div className="notify" style={{ backgroundColor: "#17A2B8" }}>
      <br />
      <span
        style={{
          float: "right",
          fontSize: "30px",
          marginTop: "-27px",
          marginRight: "6px",
        }}
      >
        &times;
      </span>
      <b className="notify" style={{ backgroundColor: "#17A2B8" }}>
        Info!
      </b>
      <p className="notify" style={{ backgroundColor: "#17A2B8" }}>
        1. This is a great way to build your knowledge of various aspects of
        BFSI and strengthen your CV. To start with, you can access free videos
        and courses.
        <br />
        2. The recommendations displayed are derived from the information that
        you have provided.
      </p>
    </div>
  );
};
const SecondMessage = () => {
  return (
    <div className="notify" style={{ backgroundColor: "#17A2B8" }}>
      <br />
      <span
        style={{
          float: "right",
          fontSize: "30px",
          marginTop: "-27px",
          marginRight: "6px",
        }}
      >
        &times;
      </span>
      <b className="notify" style={{ backgroundColor: "#17A2B8" }}>
        Info!
      </b>
      <p className="notify" style={{ backgroundColor: "#17A2B8" }}>
        1. Make today your lucky day! A completed profile is 5X MORE likely to
        be selected by the Corporates.
        <br /> 2. The recommendations displayed are derived from the information
        that you have provided.
      </p>
    </div>
  );
};
const DocMessage = () => {
  return (
    <div className="notify" style={{ backgroundColor: "#17A2B8" }}>
      <br />
      <span
        style={{
          float: "right",
          fontSize: "30px",
          marginTop: "-27px",
          marginRight: "6px",
        }}
      >
        &times;
      </span>
      <b className="notify" style={{ backgroundColor: "#17A2B8" }}>
        Info!
      </b>
      <p className="notify" style={{ backgroundColor: "#17A2B8" }}>
        a. Uploading your documents will enhance your profile credibility.
        <br />
        b. To enhance your Employability Score, please complete all the details
        in this section.
      </p>
    </div>
  );
};
const DeploymentMessage = (props) => {
  return (
    <div
      className="notify"
      style={{
        backgroundColor: "rgb(199 235 0)",
        padding: "3px",
        margin: "2px",
      }}
    >
      <br />
      <span
        style={{
          float: "right",
          fontSize: "30px",
          marginTop: "-27px",
          marginRight: "6px",
        }}
      >
        &times;
      </span>
      <p
        className="notify"
        style={{
          backgroundColor: "rgb(199 235 0)",
          padding: "3px",
          margin: "2px",
        }}
      >
        <div
          className="popup-content"
          style={{
            backgroundColor: "rgb(199 235 0)",
            padding: "3px",
            margin: "2px",
          }}
        >
          <div className="deployment-wrapper">
            <div className="deployment-icons">
              <div className="deployment-icon-wrapper">
                <svg
                  className="deployment-gear deployment-gear1"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                >
                  <path d="M19.14 12.936c.02-.15.02-.3.02-.45s-.02-.3-.02-.45l2.06-1.6c.19-.14.22-.4.06-.58l-2-3.46c-.15-.24-.39-.34-.62-.24l-2.4.98a6.927 6.927 0 0 0-1.17-.7l-.36-2.64c-.04-.26-.24-.45-.5-.45h-4c-.26 0-.46.2-.5.45l-.36 2.64c-.43.27-.85.55-1.25.85l-2.4-.98c-.24-.1-.48-.01-.62.24l-2 3.46c-.16.18-.13.44.06.58l2.06 1.6c-.02.15-.02.3-.02.45s.02.3.02.45l-2.06 1.6c-.19.14-.22.4-.06.58l2 3.46c.15.24.39.34.62.24l2.4-.98c.4.3.82.58 1.25.85l.36 2.64c.04.26.24.45.5.45h4c.26 0 .46-.2.5-.45l.36-2.64c.43-.27.85-.55 1.25-.85l2.4.98c.24.1.48.01.62-.24l2-3.46c.16-.18.13-.44-.06-.58l-2.06-1.6zM12 15.36l-1.41-1.41 3.75-3.75 1.41 1.41-3.75 3.75z" />
                </svg>
                <svg
                  className="deployment-gear deployment-gear2"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                >
                  <path d="M19.14 12.936c.02-.15.02-.3.02-.45s-.02-.3-.02-.45l2.06-1.6c.19-.14.22-.4.06-.58l-2-3.46c-.15-.24-.39-.34-.62-.24l-2.4.98a6.927 6.927 0 0 0-1.17-.7l-.36-2.64c-.04-.26-.24-.45-.5-.45h-4c-.26 0-.46.2-.5.45l-.36 2.64c-.43.27-.85.55-1.25.85l-2.4-.98c-.24-.1-.48-.01-.62.24l-2 3.46c-.16.18-.13.44.06.58l2.06 1.6c-.02.15-.02.3-.02.45s.02.3.02.45l-2.06 1.6c-.19.14-.22.4-.06.58l2 3.46c.15.24.39.34.62.24l2.4-.98c.4.3.82.58 1.25.85l.36 2.64c.04.26.24.45.5.45h4c.26 0 .46-.2.5-.45l.36-2.64c.43-.27.85-.55 1.25-.85l2.4.98c.24.1.48.01.62-.24l2-3.46c.16-.18.13-.44-.06-.58l-2.06-1.6zM12 15.36l-1.41-1.41 3.75-3.75 1.41 1.41-3.75 3.75z" />
                </svg>
              </div>
            </div>
            <div
              className="deployment-text"
              style={{
                padding: "0px",
                borderRadius: "5px",
                backgroundColor: "rgb(199 235 0)",
                fontSize: "14px",
              }}
            >
              <span>
                <strong>
                  <h4 style={{ textAlign: "center" }}>
                    <span role="img" aria-label="Warning">
                      ⚠️
                    </span>{" "}
                    Important Notice:
                  </h4>
                </strong>
                <br />
                1. Our system will undergo scheduled maintenance starting on{" "}
                <span style={{ color: "green" }}>
                  {" "}
                  {props.updatedTimeNotiRemaining}
                </span>
                . The maintenance is expected to be completed within{" "}
                <span style={{ color: "green" }}>30 to 45 minutes.</span>
                <br />
                2. During this period, access to the system may be temporarily
                unavailable or limited. Please ensure you save your work before
                the maintenance begins. We apologize for any inconvenience and
                appreciate your understanding as we work to enhance our
                services.
              </span>
            </div>
          </div>
        </div>
      </p>
    </div>
  );
};

const CollegeSuccessMsg = ({ message }) => (
  <div
    className="notify"
    style={{
      backgroundColor: "#28a745",
      borderLeft: "8px solid #1f8838",
      color: "white",
      borderRadius: "10px",
      padding: "20px 25px",
      fontSize: "18px",
      width: "420px",
      lineHeight: "1.6",
      boxShadow: "0px 4px 12px rgba(0,0,0,0.2)",
      position: "relative",
    }}
  >
    <span
      style={{
        position: "absolute",
        top: "10px",
        right: "15px",
        fontSize: "28px",
        cursor: "pointer",
        fontWeight: "bold",
      }}
    >
      &times;
    </span>
    <b
      className="notify-title"
      style={{
        display: "block",
        fontSize: "22px",
        marginBottom: "8px",
        backgroundColor: "#28a745",
      }}
    >
      <span role="img" aria-label="Success Tick">
        ✅
      </span>{" "}
      Success!
    </b>
    <p
      className="notify-message"
      style={{
        margin: 0,
        fontSize: "18px",
        fontWeight: 500,
        color: "black",
        backgroundColor: "#28a745",
      }}
    >
      {message}
    </p>
  </div>
);

export {
  FirstMessage,
  SecondMessage,
  DocMessage,
  DeploymentMessage,
  CollegeSuccessMsg,
};
